import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { AssociacaoGerenciadorComponent } from "./associacao-gerenciador/associacao-gerenciador/associacao-gerenciador.component";
import { AssociacaoService } from "./associacao-stepper/associacao.service";
import { AssociacaoStepperComponent } from "./associacao-stepper/associacao-stepper.component";
import { AssociacaoTabComponent } from "./associacao-tab/associacao-tab.component";
import { AutocompleteModule } from "maps-angular-components";
import { CarteiraModule } from "../carteira/carteira.module";
import { CommonModule } from "@angular/common";
import { DatepickerModule } from "maps-angular-components";
import { DirectivesModule } from "maps-angular-components";
import { ExecucaoVigenciaComponent } from "./associacao-stepper/execucao-vigencia/execucao-vigencia.component";
import { MatButtonModule } from "@angular/material/button";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatDialogModule } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatRadioModule } from "@angular/material/radio";
import { MatSelectModule } from "@angular/material/select";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatStepperModule } from "@angular/material/stepper";
import { MatTableModule } from "@angular/material/table";
import { MatTabsModule } from "@angular/material/tabs";
import { ModalDeletarAssociacaoDialogComponent } from "./associacao-gerenciador/associacao-gerenciador/modal-deletar-associacao/modal-deletar-associacao.component";
import { NgModule } from "@angular/core";
import { PaginationMapsModule } from "maps-angular-components";
import { RegraModule } from "../regra/regra.module";
import { SelecaoCarteiraComponent } from "./associacao-stepper/selecao-carteira/selecao-carteira.component";
import { SharedModule } from "../shared/shared.module";
import { TabsModule } from "ngx-bootstrap";
import {MatMenuModule} from "@angular/material/menu";
import { CarteiraAutocompleteModule } from "../shared/components/carteira-autocomplete/carteira-autocomplete.module";

@NgModule({
  declarations: [
    AssociacaoTabComponent,
    AssociacaoStepperComponent,
    SelecaoCarteiraComponent,
    ExecucaoVigenciaComponent,
    ModalDeletarAssociacaoDialogComponent,
    AssociacaoGerenciadorComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    TabsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatStepperModule,
    CarteiraModule,
    RegraModule,
    MatDialogModule,
    AutocompleteModule,
    DatepickerModule,
    PaginationMapsModule,
    MatRadioModule,
    MatSelectModule,
    MatTabsModule,
    MatTableModule,
    MatCheckboxModule,
    MatSlideToggleModule,
    MatButtonModule,
    DirectivesModule,
    MatInputModule,
    ReactiveFormsModule,
    FormsModule,
    MatMenuModule,
    CarteiraAutocompleteModule
  ],
  providers: [AssociacaoService],
  entryComponents: [
    ModalDeletarAssociacaoDialogComponent,
  ],
})
export class AssociacaoModule {}
